module.exports = __webpack_public_path__ + "1de57f2a9396a1bb33258b968c09dc34.svg";